module.exports = __webpack_public_path__ + "static/media/insurance.370fbd64.svg";